export const EMAIL_SEND_REQUEST = 'EMAIL_SEND_REQUEST'
export const EMAIL_SEND_SUCCESS = 'EMAIL_SEND_SUCCESS'
export const EMAIL_SEND_FAIL = 'EMAIL_SEND_FAIL'
